import { Axios } from './Axios';

export async function uploadFile(classId, fileObj) {
  const url = classId ? `live/file-upload?classId=${classId}` : 'live/file-upload';
  return Axios({
    url,
    method: 'post',
    data: fileObj
  });
}
